exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".ZXyDgT1vSa22MgM7SkVqj{width:280px;overflow:hidden}", ""]);
// Exports
exports.locals = {
	"dialog": "ZXyDgT1vSa22MgM7SkVqj"
};